import*as e from"react";const t=e.createContext({isFieldsetDisabled:!1}),o=()=>e.useContext(t);export{t as FieldsetContext,o as useFieldset};
